import FetchService from "./Shared/FetchService";
const baseURL = "/aviso/smsConfiguration";
export default class SMSConfigurationService {
    static getSmsConfiguration() {
        return FetchService.get(baseURL + "/getConfiguration");
    }
}
